module.exports = __webpack_public_path__ + "static/media/Equal-Play-Thesis-EN.88eb0a23.pdf";